import { Route, Routes } from "react-router-dom";
import CallsPage from "../../pages/features/calls/CallsPage";
import CallDetailsPage from "../../pages/features/calls/CallDetailsPage";



export default function CallNav() {
  return (
    <Routes>
      <Route path="/" element={<CallsPage />} />
      <Route path="/:id" element={<CallDetailsPage />} />

    </Routes>
  );
}
